import React, { useState, useEffect, useRef } from 'react';

const CurvedMorphingText = ({ texts, className = "", animationDelay = 0 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const animationRef = useRef(null);

  useEffect(() => {
    // Sync with ripple breathing pattern
    // Ripple cycle: 4s duration, change text at peak (2s mark)
    const rippleCycle = 4000; // 4 seconds
    const changeAtPeak = rippleCycle / 2; // Change at peak (2s)
    
    const startAnimation = () => {
      setTimeout(() => {
        const cycleInterval = setInterval(() => {
          // Change text at ripple peak
          setTimeout(() => {
            setIsAnimating(true);
            
            setTimeout(() => {
              setCurrentIndex((prevIndex) => (prevIndex + 1) % texts.length);
              setIsAnimating(false);
            }, 200); // Quick transition
            
          }, changeAtPeak);
          
        }, rippleCycle);
        
        animationRef.current = cycleInterval;
      }, animationDelay); // Delay to sync with specific circle
    };

    startAnimation();

    return () => {
      if (animationRef.current) {
        clearInterval(animationRef.current);
      }
    };
  }, [texts.length, animationDelay]);

  return (
    <div className={`absolute inset-0 z-10 pointer-events-none ${className}`}>
      <svg 
        width="100%" 
        height="100%" 
        viewBox="0 0 400 400" 
        className="absolute top-0 left-0 w-full h-full"
      >
        <defs>
          <path
            id="curved-path"
            d="M 200 50 A 150 150 0 0 1 350 200"
            fill="none"
          />
        </defs>
        <text 
          className={`text-sm md:text-base lg:text-lg font-medium tracking-widest fill-white/80 transition-all duration-1000 ${
            isAnimating ? 'opacity-0 blur-sm' : 'opacity-100 blur-0'
          }`}
          style={{
            filter: 'drop-shadow(0 0 10px rgba(255, 255, 255, 0.3))',
          }}
        >
          <textPath href="#curved-path" startOffset="0%">
            {texts[currentIndex]}
          </textPath>
        </text>
      </svg>
    </div>
  );
};

export default CurvedMorphingText;